import { useCallback } from 'react';
import { Layout } from 'antd';
import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import { AccordionSideMenu } from '@Components/index';
import {
  useAppDispatch,
  useAppSelector,
  useLogout,
  useRequestFromPage,
} from '@Hooks/index';
import { usePageType } from '@Hooks/usePageType';
import { getIsToggleSideMenu } from '@Store/selectors/activeSideMenuSelector';
import { activeSideMenuActions } from '@Store/slices/activeSideMenuSlice';

import { ReactComponent as LogoutIcon } from '@Icons/menu/logout.svg';
import { ReactComponent as OpenMenuIcon } from '@Icons/menu/open-menu.svg';
import { ReactComponent as CloseMenuIcon } from '@Icons/menu/close-menu.svg';
import logoDark from '@Images/logo-dark.png';

import styles from './desktop-layout.module.css';

const { Sider, Content } = Layout;

interface DesktopLayoutProps {
  children: JSX.Element | JSX.Element[];
}

const DesktopLayout: React.FC<DesktopLayoutProps> = ({ children }) => {
  const { logout } = useLogout();
  const dispatch = useAppDispatch();
  const toggleMenu = useAppSelector(getIsToggleSideMenu);
  const pageType = usePageType();
  const isRequestFormPage = useRequestFromPage();

  const handleToggleSideMenu = (): void => {
    dispatch(activeSideMenuActions.setToggleSideMenu(!toggleMenu));
  };

  const handleLogout = useCallback((): void => {
    logout();
  }, []);

  return (
    <>
      <Sider
        trigger={null}
        collapsible
        collapsed={toggleMenu}
        className="trojan-sider"
        width="272"
      >
        <div className={styles.logoSection}>
          {!toggleMenu && (
            <img
              className={styles.headerImage}
              src={logoDark}
              alt="Trojan construction company logotype"
            />
          )}

          <div
            className={classNames(
              styles.logoSectionButton,
              toggleMenu ? styles.buttonCloseMenu : null
            )}
            onClick={handleToggleSideMenu}
          >
            {toggleMenu ? <CloseMenuIcon /> : <OpenMenuIcon />}
          </div>
        </div>
        <div className={styles.menuWrapper}>
          <AccordionSideMenu pageType={pageType} />
        </div>
        <div className={styles.menuLogout} onClick={handleLogout}>
          <LogoutIcon /> {!toggleMenu ? 'Logout' : null}
        </div>
      </Sider>
      <Layout>
        {children}
        <Content className={styles.wrapper}>
          <Outlet context={{ isRequestFormPage }} />
        </Content>
      </Layout>
    </>
  );
};

export default DesktopLayout;
